import { CallsDetailsResponse } from './CallsDetailsList.types'

class CallsDetailsListMapper {
  toDomain(persistenceData: CallsDetailsResponse) {
    return {
      callsId: persistenceData?.id,
      hourDate: persistenceData?.dataHoraFmtSeconds,
      datails: persistenceData?.detalhes,
      eventZoom: persistenceData?.eventoZoom,
    }
  }
}

export default new CallsDetailsListMapper()
